module.exports = __webpack_public_path__ + "static/img/icon3.9f3a3af7.png";